import axiosInstance, { BASE_URL } from "./instance";

const CUSTOMER_DOMAIN = `${BASE_URL}/customer`;

const getCustomerByPhone = (params: any) => {
  return axiosInstance.get(`${CUSTOMER_DOMAIN}/customers/info?phone=${params}`);
};

const businessServices = {
  getCustomerByPhone,
};

export default businessServices;
